import { Flex, Tag } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { OrcamentoCotacaoFornecedor } from "features/orcamento/typings";
import { mapFormaPagamentoToLabel } from "infra/helpers/mapFormaPagamentoToLabel";
import moment from "moment";
import { FaPaperclip } from "react-icons/fa";
import ContentItem from "ui/components/ContentItem";

interface DescricaoCotacaoProps {
  item: OrcamentoCotacaoFornecedor;
}

export default function DescricaoCotacao({ item }: DescricaoCotacaoProps) {
  return (
    <>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={9}>
          <ContentItem
            titulo="Nome do fornecedor "
            descricao={item.nomeFornecedor ? item.nomeFornecedor : "--"}
          />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Telefone"
            descricao={item.contato ? item.contato : "--"}
          />
        </Flex>
        <Flex as={Col} xs={9}>
          <ContentItem
            titulo="Email"
            descricao={item.email ? item.email : "--"}
          />
        </Flex>
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={9}>
          <ContentItem
            titulo="Data da cotação"
            descricao={
              item.dataCotacao
                ? moment(item.dataCotacao).format("DD/MM/YYYY")
                : "--"
            }
          />
        </Flex>

        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Válido até"
            descricao={
              item.dataValidade
                ? moment(item.dataValidade).format("DD/MM/YYYY")
                : "--"
            }
          />
        </Flex>
        <Flex as={Col} xs={9}>
          <ContentItem
            titulo="Forma de pagamento"
            descricao={
              item.formaPagamentoId
                ? mapFormaPagamentoToLabel(item.formaPagamentoId)
                : "--"
            }
          />
        </Flex>
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={24}>
          <ContentItem
            titulo="Observação"
            descricao={item.observacao ? item.observacao : "--"}
          />
        </Flex>
      </Flex>

      <Flex gap={2} flexWrap="wrap" w="100%">
        {item.anexos?.length ? (
          <Tag colorScheme="gray">
            <FaPaperclip style={{ marginRight: 4 }} />
            Contém anexos
          </Tag>
        ) : null}
      </Flex>
    </>
  );
}
